import React from "react";
import "./Projects.css";
import ttt from "../../assests/ttt.png";
import np from "../../assests/np.png";
import lyricsWeb from "../../assests/lyricsWeb.png";
import fbg from "../../assests/fbg.png";
import snake from "../../assests/snake.png";
import googleclone from "../../assests/googleclone.png";
import opencv from "../../assests/opencv.png";

export default function Project() {
  return (
    <div id="project">
      <div className="project">
        <div className="title-skills">
          <h3 className="text1-skills animate__animated animate__fadeInUp wow">
            I have worked <span className="span-footer">on</span>
          </h3>
        </div>
        <div className="project-content">
          <a
            className="card"
            href="https://tictactoe-by-arjun-chauhan.netlify.app/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={ttt} alt="" />
            <h3 className="text3-project animate__animated animate__fadeInUp wow">
              Tic Tac <span>Toe</span>
            </h3>
            <p className="para-project animate__animated animate__fadeInUp wow">
              Tic Tac Toe game using Vanilla HTML,CSS,JavaScript. Fully
              responsive with classic UI
            </p>
          </a>

          <a
            className="card animate__animated animate__fadeInUp wow"
            href="https://notesapp-by-arjun-chauhan.netlify.app/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={np} alt="" />
            <h3 className="text3-project animate__animated animate__fadeInUp wow">
              Notes<span>App</span>
            </h3>
            <p className="para-project animate__animated animate__fadeInUp wow">
              NotesApp game using Vanilla HTML,CSS,JavaScript. Fully responsive
              with classic UI
            </p>
          </a>

          <a
            className="card animate__animated animate__fadeInUp wow"
            href="https://google-clone-by-arjun-chauhan.netlify.app/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={googleclone} alt="" />
            <h3 className="text3-project animate__animated animate__fadeInUp wow">
              Google<span>Clone</span>
            </h3>
            <p className="para-project animate__animated animate__fadeInUp wow">
              Google Clone using react.js and google search api's.
            </p>
          </a>

          <a
            className="card animate__animated animate__fadeInUp wow"
            href="https://github.com/RockstArjun/LyricsWeb"
            target="_blank"
            rel="noreferrer"
          >
            <img src={lyricsWeb} alt="" />
            <h3 className="text3-project animate__animated animate__fadeInUp wow">
              Lyrics<span>Web</span>
            </h3>
            <p className="para-project animate__animated animate__fadeInUp wow">
              A responsive website where you find lyrics of Songs.
            </p>
          </a>

          <a
            className="card animate__animated animate__fadeInUp wow"
            href="https://github.com/RockstArjun/Flappy-Bird-Game"
            target="_blank"
            rel="noreferrer"
          >
            <img src={fbg} alt="" />
            <h3 className="text3-project animate__animated animate__fadeInUp wow">
              Flappy Bird <span>Game</span>
            </h3>
            <p className="para-project animate__animated animate__fadeInUp wow">
              Flappy Bird game using pygame in Python.
            </p>
          </a>

          <a
            className="card animate__animated animate__fadeInUp wow"
            href="https://github.com/RockstArjun/Small-Project/blob/master/Snake_Game.py"
            target="_blank"
            rel="noreferrer"
          >
            <img src={snake} alt="" />
            <h3 className="text3-project animate__animated animate__fadeInUp wow">
              Snake <span>Game</span>
            </h3>
            <p className="para-project animate__animated animate__fadeInUp wow">
              Snake game using pygame in Python.
            </p>
          </a>

          <a
            className="card animate__animated animate__fadeInUp wow"
            href="https://github.com/RockstArjun/AirDrawing"
            target="_blank"
            rel="noreferrer"
          >
            <img src={opencv} alt="" />
            <h3 className="text3-project animate__animated animate__fadeInUp wow">
              Air<span>Drawing</span>
            </h3>
            <p className="para-project animate__animated animate__fadeInUp wow">
              Air Drawing project using OpenCV-Python.
            </p>
          </a>
        </div>
      </div>
    </div>
  );
}
